(function () {
  function initVikingoProductPage(root) {
    if (!root || root.dataset.vkpInitialized === 'true') return;

    root.dataset.vkpInitialized = 'true';

    const stickyBar = root.querySelector('[data-vkp-stickybar]');
    const stickyPrice = root.querySelector('[data-vkp-sticky-price]');
    const stickyButton = root.querySelector('[data-vkp-sticky-button]');
    const priceSource =
      root.querySelector('.ap-productmeta__price-list-container') ||
      root.querySelector('.vkpdp__price-box') ||
      root.querySelector('.price');

    function getMainButton() {
      return (
        root.querySelector('button#AddToCart') ||
        root.querySelector('button[name="add"]') ||
        root.querySelector('.ap-productform__buy-buttons button')
      );
    }

    function syncStickyBar() {
      const mainButton = getMainButton();

      if (stickyPrice && priceSource) {
        stickyPrice.innerHTML = priceSource.innerHTML;
      }

      if (stickyButton && mainButton) {
        const buttonText =
          mainButton.textContent &&
          mainButton.textContent.trim().length > 0
            ? mainButton.textContent.trim()
            : stickyButton.dataset.defaultLabel || 'Añadir al carrito';

        stickyButton.textContent = buttonText;
        stickyButton.disabled = mainButton.disabled;
      }
    }

    if (stickyButton) {
      stickyButton.addEventListener('click', function () {
        const mainButton = getMainButton();
        if (!mainButton || mainButton.disabled) return;
        mainButton.click();
      });
    }

    syncStickyBar();

    if (priceSource) {
      const priceObserver = new MutationObserver(syncStickyBar);
      priceObserver.observe(priceSource, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    const buttonObserverTarget =
      root.querySelector('.ap-productform') ||
      root.querySelector('.product__info');

    if (buttonObserverTarget) {
      const buttonObserver = new MutationObserver(syncStickyBar);
      buttonObserver.observe(buttonObserverTarget, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['disabled', 'class']
      });
    }

    const exclusiveAccordion = root.querySelector('[data-vkp-exclusive-accordion]');

    if (exclusiveAccordion) {
      const accordionItems = exclusiveAccordion.querySelectorAll('details');

      accordionItems.forEach((item) => {
        item.addEventListener('toggle', function () {
          if (!item.open) return;

          accordionItems.forEach((otherItem) => {
            if (otherItem !== item) {
              otherItem.removeAttribute('open');
            }
          });
        });
      });
    }

    const stickyObserverTarget =
      root.querySelector('.vkpdp__buy-panel') ||
      root.querySelector('.product__info');

    if (stickyBar && stickyObserverTarget && 'IntersectionObserver' in window) {
      const barObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach((entry) => {
            stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
          });
        },
        {
          threshold: 0.18
        }
      );

      barObserver.observe(stickyObserverTarget);
    }
  }

  function boot() {
    document.querySelectorAll('[data-vkp-root]').forEach(initVikingoProductPage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();